export function generateRandomHexColorAvoidingSome() {
  // Cores a evitar (em formato RGB)
  const avoidColors = [
    { r: 253, g: 192, b: 15 }, // #FDC00F
    { r: 20, g: 176, b: 191 }, // #14B0BF
    { r: 238, g: 115, b: 135 }, // #ee7387
    { r: 255, g: 0, b: 0 }, // #FF0000
  ]

  // Função para calcular a distância Euclidiana entre duas cores RGB
  function colorDistance(c1, c2) {
    return Math.sqrt(Math.pow(c1.r - c2.r, 2) + Math.pow(c1.g - c2.g, 2) + Math.pow(c1.b - c2.b, 2))
  }

  // Função para gerar cor aleatória e verificar se está muito próxima das cores a evitar
  function generateColor() {
    let rgbColor

    do {
      // Gera um número aleatório de 0 a 16777215 (cor RGB em hexadecimal)
      const randomColorValue = Math.floor(Math.random() * 16777215)

      // Converte para RGB
      rgbColor = {
        r: (randomColorValue >> 16) & 0xff,
        g: (randomColorValue >> 8) & 0xff,
        b: randomColorValue & 0xff,
      }

      // Verifica se a cor gerada está próxima das cores a evitar
      var tooClose = false
      for (const avoidColor of avoidColors) {
        if (colorDistance(rgbColor, avoidColor) < 100) {
          // 100 é um limite de proximidade
          tooClose = true
          break
        }
      }

      // Se a cor for muito próxima de alguma das cores a evitar, gera outra
    } while (tooClose)

    // Retorna a cor em formato hex
    return `#${((1 << 24) | (rgbColor.r << 16) | (rgbColor.g << 8) | rgbColor.b).toString(16).slice(1).toUpperCase()}`
  }

  return generateColor()
}

export function generateRandomHexColor() {
  const randomColor = Math.floor(Math.random() * 16777215)
  return `#${randomColor.toString(16).padStart(6, '0')}`
}
